import { CarrierServiceType } from '@rebound/shared-models/carrier/carrier.model';
import {
  DraftReturnItemAction,
  DraftReturnItemReason,
} from '@rebound/shared-models/draft-return/draft-return.model';

export type SelectItemsForm = {
  quantity: number;
  returnOption: DraftReturnItemAction;
  reasons: DraftReturnItemReason[];
};

export enum ReturnJourneyStepSlug {
  SelectItems = 'select-items',
  PersonalInformation = 'personal-information',
  SelectCarrier = 'select-carrier',
  PayForDelivery = 'pay-for-delivery',
  Summary = 'summary',
}

export type PersonalInformationFormValues = {
  name: string;
  email: string;
  phoneNumber: string;
  country: string;
  county: string;
  postCode: string;
  city: string;
  state: string;
  address1: string;
  address2: string;
};

export type CarrierInformationFormValues = {
  address1: string;
  phoneNumber: string;
  cycleonRmaNumber: string;
  county: string;
  companyName: string;
  approvedMessage: boolean;
};

export enum SummaryPanelVariant {
  Mobile = 'Mobile',
  Laptop = 'Laptop',
}

export type DraftReturnCarrierFormData = {
  carrierServiceId: number | null;
  carrierServiceName: string;
  carrierServiceType: CarrierServiceType | string;
  postalCompanyId: number | null;
  carrierServiceImgPath: string;
  collectionDate: Date | null;
  collectionInterval: number | null;
  dropOffPointId: string;
  dropOffPointAddress: string;
  isCarrierServiceFree: boolean;
  deliveryPrice: number;
  deliveryCurrency: string;
};

export type DropOffLocationFormType = {
  postcode: string;
};

export enum FeedbackSteps {
  Rate = 'Rate',
  Note = 'Note',
}

export type FeedbackFormValues = {
  note: string;
};

export type QueryParams = {
  orderReference: string;
  email: string;
  postalCode: string;
  lang: string;
};
